.termsContainer {
  background-color: var(--bg-canvas);
  padding: var(--spacing-5xl) 0 var(--spacing-2xl);
}

.termsCard {
  max-width: 750px;
  margin: 40px auto;
}

.welcome {
  border-bottom: 1px solid var(--border-default);
}

.revisedDate {
  font-weight: bold;
  margin-bottom: 20px;
}

.sectionNumber {
  padding-right: 10px;
}

.termsSection {
  > p,
  li {
    margin-bottom: 20px;
  }
}

.linkWrapper {
  white-space: nowrap;
}

.alphaList {
  padding-left: 0;
  list-style-type: none;
}

.agentInfo {
  ul {
    padding-top: 10px;
    padding-left: 10px;
  }

  li {
    list-style-type: disc;
    font-weight: 300;
  }
}
